import React from 'react';
import IconSelectCheck from '~/components/svg/icon-check-select.svg';
import themeVariables from '~/shared/themeVariables';
import Config from '~/config';

const Index = (props) => {
  const { checked, label, onChange } = props;
  return (
    <div
      className={`container-select ${checked ? 'active' : ''}`}
      onClick={onChange}
    >
      <div className="select-list">{label}</div>
      <div className="icon-select">{checked && <IconSelectCheck />}</div>
      <style jsx>
        {`
          .container-select {
            display: flex;
            height: 44px;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            padding: 8px 16px;
            cursor: pointer;
          }
          .active {
            background: ${Config.isIllustAC() ? '#FBEBED' : '#c4c4c4'};
          }
          .container-select:hover {
            background: ${Config.isIllustAC() ? '#FBEBED' : '#c4c4c4'};
          }
          .select-list {
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
          }
        `}
      </style>
    </div>
  );
};
export default Index;
